"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = EmployeePermissionsCard;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const UserContext_1 = require("../contexts/UserContext");
const react_i18next_1 = require("react-i18next");
const react_native_1 = require("react-native");
const cancelable_promise_1 = require("cancelable-promise");
const MyProfile_1 = __importDefault(require("../api/MyProfile"));
const Card_1 = __importDefault(require("../components/Card"));
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const Loading_1 = __importDefault(require("../components/Loading"));
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const CardTitle_1 = __importDefault(require("../components/CardTitle"));
const Button_1 = __importDefault(require("../components/Button"));
const ElevatePermissions_1 = __importDefault(require("../ElevatePermissions"));
const Field_1 = __importDefault(require("../components/Field"));
const FadeInView_1 = __importDefault(require("../components/FadeInView"));
function EmployeePermissionsCard(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const promise = react_1.default.useRef(null);
    const [status, setStatus] = react_1.default.useState(null);
    const [permissions, setPermissions] = react_1.default.useState(null);
    const [role, setRole] = react_1.default.useState(null);
    const [riskAndCompliance] = react_1.default.useState(userContext.client?.features?.find((feature) => feature.name === 'wc-risk'));
    const riskAndComplianceDisabled = riskAndCompliance == null || !riskAndCompliance?.isEnabled;
    const refresh = react_1.default.useCallback(() => {
        promise.current?.cancel();
        setStatus("loading");
        promise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then((token) => MyProfile_1.default.getPermissions(token, props.employeeId))).then((data) => {
            setRole(data.role);
            setPermissions(data.permissions);
            setStatus("done");
        }).catch((e) => {
            setStatus("error");
        });
    }, []);
    react_1.default.useEffect(() => {
        refresh();
        return () => {
            promise.current?.cancel();
            react_native_1.DeviceEventEmitter.removeAllListeners("event.permissionsUpdate");
        };
    }, []);
    const editInfo = () => {
        props.navigation.navigate("PermissionsEdit", { id: props.employeeId, name: props.name ?? '' });
        react_native_1.DeviceEventEmitter.addListener("event.permissionsUpdate", () => refresh());
    };
    const allowed = Object.getOwnPropertyNames(ElevatePermissions_1.default)
        .filter(p => permissions?.includes(ElevatePermissions_1.default[p]))
        .filter(x => {
        if (role?.includes('A'))
            return x != 'CoIAccess';
        if (riskAndComplianceDisabled)
            return false;
        else
            return x == 'CoIAccess';
    })
        .map(x => t(`profile:labels.${x}`)).join(", ");
    const denied = Object.getOwnPropertyNames(ElevatePermissions_1.default)
        .filter(p => !permissions?.includes(ElevatePermissions_1.default[p]))
        .filter(x => {
        if (role?.includes('A'))
            return x != 'CoIAccess';
        if (riskAndComplianceDisabled)
            return false;
        else
            return x == 'CoIAccess';
    })
        .map(x => t(`profile:labels.${x}`)).join(", ");
    return userContext.isAdmin && allowed.concat(denied).length != 0 ? ((0, jsx_runtime_1.jsxs)(Card_1.default, { children: [(0, jsx_runtime_1.jsx)(CardTitle_1.default, { title: t('profile:text.permissions'), children: userContext.permissions?.includes(ElevatePermissions_1.default.ManagePermissions) &&
                    (0, jsx_runtime_1.jsxs)(Button_1.default, { type: "outline", onPress: () => editInfo(), children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Primary, fontSize: 14, fontWeight: '500', marginHorizontal: 6 }, children: t('common:buttons.edit') }), (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { color: THEME.Primary, icon: Theme_1.ICONS.Regular.Pen, size: 14, style: { marginRight: 6 } })] }) }), status == "done"
                &&
                    (0, jsx_runtime_1.jsxs)(FadeInView_1.default, { children: [(0, jsx_runtime_1.jsx)(Field_1.default, { caption: t('profile:text.allowed'), value: allowed ? allowed : "—" }), (0, jsx_runtime_1.jsx)(Field_1.default, { caption: t('profile:text.denied'), value: denied ? denied : "—" })] })
                ||
                    (0, jsx_runtime_1.jsx)(Loading_1.default, { retryable: true, loading: status == "loading", error: status == "error", onRetry: () => refresh() })] })) :
        null;
}
